import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { ToastrService } from 'ngx-toastr';
import { BaseDialogComponent } from 'src/app/shared/base/dialog/dialog.component';
import { EmitType } from '@syncfusion/ej2-base';
import { protectedResources } from 'src/app/auth-config';
import ConvertUtils from 'src/app/shared/Utility/ConvertUtils';
import DateUtils from 'src/app/shared/Utility/DateUtils';
import { highlightSearch } from '@syncfusion/ej2-angular-dropdowns';
import { HttpErrorResponse } from '@angular/common/http';
import { DownloadFileComplete, DownloadFileProgress } from 'src/app/shared/directives/download-file-directive.directive';
import { DOWNLOAD_DIALOG_WIDTH, formatFileNameDate, formatMegabytes, readNotebookNotificationAttributes } from '../notebook-download/notebook-download-state';
import ErrorHandling from 'src/app/shared/Utility/ErrorHandling';


enum DownloadFileType {
  PDF,
  ZIP
}

@Component({
  selector: 'app-download-confirmation-dialog',
  templateUrl: './download-confirmation-dialog.component.html',
  styleUrls: ['./download-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadConfirmationDialogComponent extends BaseDialogComponent implements OnInit {

  downloadRelatedNodeID: string = "";
  downloadNotebookbookID: string = "";
  downloadNotebookName: string = "";
  downloadFileType: string = "application/pdf";   // default 20
  downloadFileExtension: string = ".pdf";
  downloadType: string = "PDF";
  downloadFileSize: number = 0;
  downloadFileSizeDisplayMB: string = "";
  downloadURL: string = "";
  showSizeWarning: boolean = false;
  fileName: string = "";
  downloadButtonLabel: string = "Download ...";   // Download PDF, Download ZIP, Download Started (depending on situation)

  urlBase = protectedResources.apiBaseUrl.endpoint;

  readonly dialogWidth = DOWNLOAD_DIALOG_WIDTH;

  /** Subtitle under "Download Notebook": "PDF" or "Full-Disclosure ZIP". */
  get formatLabel(): string {
    return this.downloadFileExtension === '.zip' ? 'Full-Disclosure ZIP' : 'PDF';
  }



  constructor(
    private toastr: ToastrService,
    public readonly cdRef: ChangeDetectorRef,
    private errorHandling: ErrorHandling
  ) {
    super(cdRef)
  }

  ngOnInit(): void {

  }

  LoadControlFromNotification(downloadGenerationID: string, categoryID: number, messageHtml: string, 
    dateGeneratedStr: string) {

    // SECURITY (2026-11-01 review): read only the single server metadata span, and refuse a
    // message with injected or duplicated attributes. The old loop read every <span> and threw
    // on any span without these attributes.
    const attributes = readNotebookNotificationAttributes(messageHtml) || {};
    const fileSize = Number(attributes['filesize']);
    this.downloadFileSize = isFinite(fileSize) ? fileSize : 0;
    this.downloadNotebookbookID = attributes['notebookid'] || '';
    this.downloadNotebookName = attributes['notebookname'] || '';

    this.downloadFileSizeDisplayMB = ConvertUtils.getMBfromBytes(this.downloadFileSize).toString() + "MB";

    this.CheckIfSizeWarningShouldBeDisplayed();

    console.log("downloadFileSize", this.downloadFileSize);
    console.log("downloadNotebookbookID", this.downloadNotebookbookID);
    console.log("downloadNotebookName", this.downloadNotebookName);
    console.log("downloadFileSizeDisplayMB", this.downloadFileSizeDisplayMB);
    console.log("categoryID", categoryID);



    if (categoryID == 20) {
      this.LoadControl(downloadGenerationID, DownloadFileType.PDF, this.downloadFileSize, this.downloadNotebookbookID, this.downloadNotebookName, dateGeneratedStr);
    }
    else if (categoryID == 21) {
      this.LoadControl(downloadGenerationID, DownloadFileType.ZIP, this.downloadFileSize, this.downloadNotebookbookID, this.downloadNotebookName, dateGeneratedStr);
    }
    else {
      console.error("UNKNOWN CATEGORY ID = " + categoryID);
    }
  }

  CheckIfSizeWarningShouldBeDisplayed() {
    if (this.downloadFileSize > 50000000) { // 50MB
      this.showSizeWarning = true;
    }

  }

  LoadControlFromSignalR(downloadGenerationID: string, notebookID: string, fileType: string, fileSize: number) {

    this.downloadFileSize = fileSize;
    this.downloadNotebookbookID = notebookID;
    this.downloadNotebookName = "";

    console.log("LoadControlFromSignalR");
    console.log("fileSize", fileSize);
    console.log("downloadFileSize", this.downloadFileSize);


    this.downloadFileSizeDisplayMB = ConvertUtils.getMBfromBytes(this.downloadFileSize).toString() + "MB";


    let downloadFileType: DownloadFileType;

    if (fileType.toUpperCase() == "PDF") {
      downloadFileType = DownloadFileType.PDF;
    }
    else if (fileType.toUpperCase() == "ZIP") {
      downloadFileType = DownloadFileType.ZIP;
    }
    else {
      console.error("Unknown File Type = " + fileType.toUpperCase());
    }

    this.CheckIfSizeWarningShouldBeDisplayed();



    this.LoadControl(downloadGenerationID, downloadFileType, fileSize, notebookID, "", formatFileNameDate(new Date()));
  }

  LoadControl(downloadGenerationID: string, downloadFileType: DownloadFileType, fileSize: number, notebookID: string, notebookName: string, dateGeneratedStr: string) {

    this.ResetDialog();
    this.downloadRelatedNodeID = downloadGenerationID;


    // Make Date valid for filename
    dateGeneratedStr = dateGeneratedStr.replace(" @ ", "-").replace(":", "-");

    console.log("dateGeneratedStr", dateGeneratedStr);



    switch (downloadFileType) {
      case DownloadFileType.PDF:
        this.downloadFileType = "application/pdf";
        this.downloadFileExtension = ".pdf";
        this.downloadType = "PDF";
        this.downloadButtonLabel = "Download PDF";
        break;

      case DownloadFileType.ZIP:
        this.downloadFileType = "application/zip";
        this.downloadFileExtension = ".zip";
        this.downloadType = "ZIP Achive";
        this.downloadButtonLabel = "Download ZIP Archive";

        break;

      default:
        console.error("UNKNOWN DownloadFileType = " + downloadFileType);
    }


    this.downloadURL = this.urlBase + "/api/Notebooks/DownloadNotebook/" + this.downloadRelatedNodeID;

    console.log("downloadURL", this.downloadURL);

    // Create a Good FileName

    if (this.downloadNotebookName) {
      this.fileName = this.downloadNotebookName + "-NotebookID-" + this.downloadNotebookbookID + "-Generated-" + dateGeneratedStr;
    }
    else {
      // Notebook Name NOT Known
      this.fileName = "NotebookID-" + this.downloadNotebookbookID + "-Generated-" + dateGeneratedStr;
    }

    console.log("fileName", this.fileName)

    this.cdRef.detectChanges();
  }


  onDialogClose(event){
    this.ResetDialog();
    super.onDialogClose(event);
  }


  ResetDialog(){
    this.isDisabled = false;
    this.isSpinnerActive = false;
    this.downloadComplete = false;
    this.downloadStartedAt = 0;
  }


  isDisabled: boolean = false;
  isSpinnerActive: boolean = false;
  downloadComplete: boolean = false;
  private downloadStartedAt: number = 0;

  onClickDownload() {
    if (this.isDisabled) {
      return;
    }
    this.downloadStartedAt = Date.now();
    this.downloadButtonLabel = "Downloading...";
    this.isDisabled = true;
    this.isSpinnerActive = true;
    this.downloadComplete = false;
    this.cdRef.detectChanges();
  }

  onDownloadProgress(progress: DownloadFileProgress) {
    const total = progress.totalBytes || this.downloadFileSize;
    this.downloadButtonLabel = total
      ? "Downloading " + formatMegabytes(progress.loadedBytes) + " of " + formatMegabytes(total) + " MB"
      : "Downloading " + formatMegabytes(progress.loadedBytes) + " MB";
    this.cdRef.detectChanges();
  }

  onDownloadComplete(result: DownloadFileComplete) {
    this.isSpinnerActive = false;
    this.downloadComplete = true;
    this.downloadButtonLabel = "Download complete";
    this.cdRef.detectChanges();
  }

  onDownloadError(error: HttpErrorResponse) {
    this.isSpinnerActive = false;
    this.isDisabled = false;
    this.downloadButtonLabel = "Retry Download";
    this.toastr.error("The download did not finish. Please try again.");
    this.errorHandling.LogErrorToServer(
      'NotebookDownload failed step=downloading source=fallback-dialog generationId=' + this.downloadRelatedNodeID +
      ' notebookId=' + this.downloadNotebookbookID + ' fileType=' + this.downloadType +
      ' elapsedMs=' + (this.downloadStartedAt ? Date.now() - this.downloadStartedAt : 0) +
      ' httpStatus=' + (error ? error.status : 'none'),
      null);
    this.cdRef.detectChanges();
  }

}
